module.exports = __webpack_public_path__ + "173ee60a15faee09e959c2f2632e138b.svg";